import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SelfHealingAppendices from "./pages/SelfHealingAppendices";
import AppendicesPage from "./pages/AppendicesPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/self-healing-appendices" element={<SelfHealingAppendices />} />
          <Route path="/appendices" element={<AppendicesPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
